import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'local',
		path: '/local/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/local" */ './index'), {
			exportName: 'Local',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
